<template>
  <div>
    <h1>rhemote coming soon!</h1>
  </div>
</template>

<script>
export default {
  name: 'ComingSoon',
};
</script>

<style scoped lang="less">

</style>
